<div class="form-group row">
    <label class="col-form-label text-bold col-sm-8" for="pageassist_logo_position" translate>
        PageAssist Logo Position
    </label>
    <div class="col-sm-40">
        <select name="pageassist_logo_position"
                class="form-control"
                id="pageassist_logo_position"
                (change)="updateDomainSettings()"
                [(ngModel)]="settings.direction">
            <option *ngFor="let dir of directions" [value]="dir.value">{{dir.name}}</option>
        </select>
    </div>
</div>
<div class="form-group row">
    <label class="col-form-label text-bold col-sm-8" for="pageassist_theme" translate>
        PageAssist Theme
    </label>
    <div class="col-sm-40">
        <select name="pageassist_theme"
                class="form-control"
                id="pageassist_theme"
                (change)="updateDomainSettings()"
                [(ngModel)]="settings.theme">
            <option *ngFor="let theme of themes" [value]="theme.value">{{theme.name}}</option>
        </select>
    </div>
</div>
<div class="row">
    <div class="offset-sm-8 col-sm-40 d-flex align-items-center">
        <form-field-material-switch class="mt-3 pr-3"
                                    name="{{prefixName}}_pageassist_skip_to"
                                    (ngChange)="updateDomainSettings()"
                                    [(ngModel)]="settings.skip_to">
        </form-field-material-switch>
        <label class="font-weight-400 my-0" for="{{prefixName}}_pageassist_skip_to" translate>
            Add Skip to PageAssist
        </label>
    </div>
</div>
